import {
  ListGroup, Row, Col, Form
} from "react-bootstrap";

import IAuthority from "interfaces/models/IAuthority";

interface UserAuthorityItemProps {
  register : any;
  authority: IAuthority;
}

const UserAuthorityItem = ({
  register, authority, ...props
} : UserAuthorityItemProps) => (
  <ListGroup.Item {...props}>
    <Row className="align-items-center">
      <Col xs={11}><Form.Label className="d-flex w-100 mb-0" htmlFor={`swAuthority_${authority.authorityId}`}>{authority.authorityName}</Form.Label></Col>
      <Col xs={1} className="d-flex justify-content-end">
        <Form.Check
          {...register("authorities")}
          id={`swAuthority_${authority.authorityId}`}
          data-testid={`swAllocate_${authority.authorityId}`}
          className="d-inline-flex custom-switch custom-switch-md ms-2"
          type="switch"
          aria-required="false"
          aria-label={`${authority.authorityName} Authority`}
          value={authority.authorityId}
        />
      </Col>
    </Row>
  </ListGroup.Item>
);

export default UserAuthorityItem;
